import React from 'react'
import './Footer.css'
const Footer = () => {
  return (
    <div className='footer'>
      <hr />
      <p>Copyright @ 2023 - All Right Reserved.</p>
    </div>
  )
}

export default Footer
